
import React from "react";

type ArrowIconProps = {
  size?: number;
  className?: string;
};

export const ArrowIcon = ({
  size,
  className,
}: ArrowIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" className={className} width={size} height={size} viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
</svg>

//<svg xmlns="http://www.w3.org/2000/svg" className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
  );
};
